import { useState } from "react";
import { usePatientSurgeryStore, useQuizStore } from "../../hooks";

export const PatientSurgeryTab = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    patientSurgery,
  } = usePatientSurgeryStore();

  const {
    // Props

    // Methods
    startQuiz,
  } = useQuizStore();

  const { assessment } = patientSurgery.data.procedure;

  // States ------------------------------------------------//
  const [activeIndex, setActiveIndex] = useState(1);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <>
      <h3 className="mb-0">Detalle de procedimiento</h3>

      <div className="w-full">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <button
              className={`nav-link ${activeIndex === 1 ? "active" : ""}`}
              aria-current="page"
              onClick={() => setActiveIndex(1)}
            >
              Encuesta
            </button>
          </li>
        </ul>
        <div className="card">
          {activeIndex === 1 && (
            <>
              <div className="fw-semibold text-primary bg-soft-primary py-3 px-4">
                Encuesta: {assessment.title}
              </div>
              <div className="card-body">
                <div className="vstack gap-3">
                  <p className="mb-0">Encuesta: {assessment.title}</p>
                  <button
                    className="btn btn-primary align-self-start"
                    type="button"
                    onClick={() => startQuiz()}
                  >
                    Iniciar encuesta
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};
